import { render, staticRenderFns } from "./FAQUsers.vue?vue&type=template&id=48d4ea0a&scoped=true"
import script from "./FAQUsers.vue?vue&type=script&lang=js"
export * from "./FAQUsers.vue?vue&type=script&lang=js"
import style0 from "./FAQUsers.vue?vue&type=style&index=0&id=48d4ea0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4ea0a",
  null
  
)

export default component.exports